module.exports = __webpack_public_path__ + "static/media/8D.fcafeaf2.png";